import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from "@ngneat/transloco";
import { EmailValidator, FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Mail } from 'src/app/model/email';
import { email, max_length_255, required } from '@utility';
import { UserDetailService } from '@services';
import { ActionResult, EventItem, UserDetail } from '@model';
import { AbstractComponent } from '../abstract.component';
import { EmailService } from 'src/app/services/email.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-organiser-contact-modal',
  templateUrl: './organiser-contact-modal.component.html',
  styleUrl: './organiser-contact-modal.component.scss'
})
export class OrganiserContactModalComponent extends AbstractComponent implements OnInit {
  @Input() currentItem: EventItem | undefined;
  messageSent: boolean | undefined;
  email: Mail | undefined;
  currentLoggedInUser: UserDetail | undefined;
  loggedIn: boolean = false;

  constructor(public translocoService: TranslocoService, public activeModal: NgbActiveModal, private modalService: NgbModal,
    private userDetailsService: UserDetailService, private emailService: EmailService) {
    super();
  }

  ngOnInit() {
    this.initForm();
    this.inputForm.controls.email.setValue(this.currentLoggedInUser?.email);
    this.subscribeToFormChanges();
  }

  inputForm = new FormGroup({
    email: new FormControl(),
    nameAndLastName: new FormControl(),
    messageSubject: new FormControl(),
    message: new FormControl(),
  });

  subscribeToFormChanges() {
    if(this.inputForm.get('email')){
      this.inputForm.get('email')?.valueChanges.subscribe((newEmail) => {
        if( this.currentLoggedInUser){
          this.currentLoggedInUser.email = newEmail;
        }
      });
    }
  }

  onSendMessage() {
    let mail: Mail;
    if(this.inputForm.valid){
    if (this.currentLoggedInUser || this.currentLoggedInUser !== undefined) {
      mail = {
        subject: this.inputForm.value.messageSubject,
        msgBody: this.inputForm.value.message,
        sender: this.currentLoggedInUser?.email,
        recipient: this.currentItem?.organiser?.email,
        optAttachments: undefined
      }
    } else {
      mail = {
        subject: this.inputForm.value.messageSubject,
        msgBody: this.inputForm.value.message,
        sender: this.inputForm.value.email,
        recipient: this.currentItem?.organiser?.email,
        optAttachments: undefined
      }
    }
    this.email = mail;
    this.sendEmail();
  }
  }

  sendEmail() {
    this.emailService.sendEmailToUser(this.email).subscribe((sent: ActionResult<boolean>): void => {
      this.messageSent = sent.success;
    });
  }

  getLoggedInUser() {
    this.subscriptions.push(this.userDetailsService.currentUserDetails.subscribe((userDetails: UserDetail | undefined) => {
      if (userDetails || userDetails !== null) {
        this.currentLoggedInUser = userDetails;
      }
    }));
  }


  private initForm() {
    this.inputForm.controls.email.addValidators([required, email]);
    this.inputForm.controls.nameAndLastName.addValidators([required]);
    this.inputForm.controls.message.addValidators([required]);
    this.inputForm.controls.messageSubject.addValidators([required]);
    this.getLoggedInUser();
  }

  onClose() {
    this.activeModal.close();
  }
}
